
export const VERSION = '5.4.17'; // Update this manually on each release

